import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { PatientResponse } from "./types";
import { formatDateOnly, toDateOnlyString } from "./datetime";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function downloadPatientsCSV(patients: PatientResponse[]) {
  // Helper function to format date
  const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return "";

    // A calendar date: formatted without any time-zone shift.
    return formatDateOnly(dateString, "MM/dd/yyyy", "");
  };

  // Create CSV headers
  const headers = ["name", "dob", "pcp", "mrn"];

  // Create CSV rows
  const rows = patients.map((patient) => {
    const name = `${patient.first_name} ${patient.last_name}`.trim();
    const dob = formatDate(patient.date_of_birth);
    const pcp = patient.provider_name || "";
    const mrn = patient.external_id || "";

    return [name, dob, pcp, mrn];
  });

  // Combine headers and rows
  const csvContent = [headers, ...rows]
    .map((row) => row.map((field) => `"${field}"`).join(","))
    .join("\n");

  // Create and download the file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `patients_${toDateOnlyString()}.csv`
  );
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadCarePlansZip(blob: Blob) {
  // Create and download the zip file
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `care_plans_${toDateOnlyString()}.zip`
  );
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL object
  URL.revokeObjectURL(url);
}
